/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfOrganizationConfirmedSafeIpDto } from '../models/custom-result-of-list-of-organization-confirmed-safe-ip-dto';
import { CustomResultOfPaginatedListOfGetConfirmUserSafeIPsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-confirm-user-safe-i-ps-with-pagination-dto';
import { CustomResultOfPaginatedListOfUserSafeIPsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-user-safe-i-ps-with-pagination-dto';
import { userSafeIPsConfirmUserSafeIps } from '../fn/user-safe-i-ps/user-safe-i-ps-confirm-user-safe-ips';
import { UserSafeIPsConfirmUserSafeIps$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-confirm-user-safe-ips';
import { userSafeIPsCreateGet } from '../fn/user-safe-i-ps/user-safe-i-ps-create-get';
import { UserSafeIPsCreateGet$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-create-get';
import { userSafeIPsCreatePost } from '../fn/user-safe-i-ps/user-safe-i-ps-create-post';
import { UserSafeIPsCreatePost$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-create-post';
import { userSafeIPsDelete } from '../fn/user-safe-i-ps/user-safe-i-ps-delete';
import { UserSafeIPsDelete$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-delete';
import { userSafeIPsGetConfirmUserSafeIPsWithPagination } from '../fn/user-safe-i-ps/user-safe-i-ps-get-confirm-user-safe-i-ps-with-pagination';
import { UserSafeIPsGetConfirmUserSafeIPsWithPagination$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-get-confirm-user-safe-i-ps-with-pagination';
import { userSafeIPsGetOrganizationConfirmedSafeIp } from '../fn/user-safe-i-ps/user-safe-i-ps-get-organization-confirmed-safe-ip';
import { UserSafeIPsGetOrganizationConfirmedSafeIp$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-get-organization-confirmed-safe-ip';
import { userSafeIPsGetUserSafeIpAudits } from '../fn/user-safe-i-ps/user-safe-i-ps-get-user-safe-ip-audits';
import { UserSafeIPsGetUserSafeIpAudits$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-get-user-safe-ip-audits';
import { userSafeIPsRejectUserSafeIp } from '../fn/user-safe-i-ps/user-safe-i-ps-reject-user-safe-ip';
import { UserSafeIPsRejectUserSafeIp$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-reject-user-safe-ip';
import { userSafeIPsSafeIPsWithPagination } from '../fn/user-safe-i-ps/user-safe-i-ps-safe-i-ps-with-pagination';
import { UserSafeIPsSafeIPsWithPagination$Params } from '../fn/user-safe-i-ps/user-safe-i-ps-safe-i-ps-with-pagination';

@Injectable({ providedIn: 'root' })
export class UserSafeIPsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userSafeIPsGetOrganizationConfirmedSafeIp()` */
  static readonly UserSafeIPsGetOrganizationConfirmedSafeIpPath = '/UserSafeIPs/GetOrganizationConfirmedSafeIp';

  /**
   * لیست آی پی های امن تایید شده سازمان جاری برای استفاده در توکن وب سرویس.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsGetOrganizationConfirmedSafeIp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsGetOrganizationConfirmedSafeIp$Response(params: UserSafeIPsGetOrganizationConfirmedSafeIp$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfOrganizationConfirmedSafeIpDto>> {
    return userSafeIPsGetOrganizationConfirmedSafeIp(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست آی پی های امن تایید شده سازمان جاری برای استفاده در توکن وب سرویس.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsGetOrganizationConfirmedSafeIp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsGetOrganizationConfirmedSafeIp(params: UserSafeIPsGetOrganizationConfirmedSafeIp$Params, context?: HttpContext): Observable<CustomResultOfListOfOrganizationConfirmedSafeIpDto> {
    return this.userSafeIPsGetOrganizationConfirmedSafeIp$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfOrganizationConfirmedSafeIpDto>): CustomResultOfListOfOrganizationConfirmedSafeIpDto => r.body)
    );
  }

  /** Path part for operation `userSafeIPsSafeIPsWithPagination()` */
  static readonly UserSafeIPsSafeIPsWithPaginationPath = '/UserSafeIPs/SafeIPsWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsSafeIPsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsSafeIPsWithPagination$Response(params: UserSafeIPsSafeIPsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfUserSafeIPsWithPaginationDto>> {
    return userSafeIPsSafeIPsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsSafeIPsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsSafeIPsWithPagination(params: UserSafeIPsSafeIPsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfUserSafeIPsWithPaginationDto> {
    return this.userSafeIPsSafeIPsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfUserSafeIPsWithPaginationDto>): CustomResultOfPaginatedListOfUserSafeIPsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `userSafeIPsGetConfirmUserSafeIPsWithPagination()` */
  static readonly UserSafeIPsGetConfirmUserSafeIPsWithPaginationPath = '/UserSafeIPs/GetConfirmUserSafeIPsWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsGetConfirmUserSafeIPsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsGetConfirmUserSafeIPsWithPagination$Response(params: UserSafeIPsGetConfirmUserSafeIPsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetConfirmUserSafeIPsWithPaginationDto>> {
    return userSafeIPsGetConfirmUserSafeIPsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsGetConfirmUserSafeIPsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsGetConfirmUserSafeIPsWithPagination(params: UserSafeIPsGetConfirmUserSafeIPsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetConfirmUserSafeIPsWithPaginationDto> {
    return this.userSafeIPsGetConfirmUserSafeIPsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetConfirmUserSafeIPsWithPaginationDto>): CustomResultOfPaginatedListOfGetConfirmUserSafeIPsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `userSafeIPsCreateGet()` */
  static readonly UserSafeIPsCreateGetPath = '/UserSafeIPs/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSafeIPsCreateGet$Response(params?: UserSafeIPsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return userSafeIPsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSafeIPsCreateGet(params?: UserSafeIPsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.userSafeIPsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `userSafeIPsCreatePost()` */
  static readonly UserSafeIPsCreatePostPath = '/UserSafeIPs/Create';

  /**
   * Create User Safe IPs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsCreatePost$Response(params: UserSafeIPsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return userSafeIPsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create User Safe IPs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsCreatePost(params: UserSafeIPsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.userSafeIPsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `userSafeIPsConfirmUserSafeIps()` */
  static readonly UserSafeIPsConfirmUserSafeIpsPath = '/UserSafeIPs/ConfirmUserSafeIps';

  /**
   * Confirm User Safe IPs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsConfirmUserSafeIps()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsConfirmUserSafeIps$Response(params: UserSafeIPsConfirmUserSafeIps$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return userSafeIPsConfirmUserSafeIps(this.http, this.rootUrl, params, context);
  }

  /**
   * Confirm User Safe IPs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsConfirmUserSafeIps$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsConfirmUserSafeIps(params: UserSafeIPsConfirmUserSafeIps$Params, context?: HttpContext): Observable<CustomResult> {
    return this.userSafeIPsConfirmUserSafeIps$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `userSafeIPsRejectUserSafeIp()` */
  static readonly UserSafeIPsRejectUserSafeIpPath = '/UserSafeIPs/RejectUserSafeIp';

  /**
   * Reject User Safe IPs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsRejectUserSafeIp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsRejectUserSafeIp$Response(params: UserSafeIPsRejectUserSafeIp$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return userSafeIPsRejectUserSafeIp(this.http, this.rootUrl, params, context);
  }

  /**
   * Reject User Safe IPs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsRejectUserSafeIp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsRejectUserSafeIp(params: UserSafeIPsRejectUserSafeIp$Params, context?: HttpContext): Observable<CustomResult> {
    return this.userSafeIPsRejectUserSafeIp$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `userSafeIPsDelete()` */
  static readonly UserSafeIPsDeletePath = '/UserSafeIPs/Delete';

  /**
   * Delete User Safe IPs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsDelete$Response(params: UserSafeIPsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return userSafeIPsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete User Safe IPs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsDelete(params: UserSafeIPsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.userSafeIPsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `userSafeIPsGetUserSafeIpAudits()` */
  static readonly UserSafeIPsGetUserSafeIpAuditsPath = '/UserSafeIPs/GetUserSafeIpAudits';

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSafeIPsGetUserSafeIpAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsGetUserSafeIpAudits$Response(params: UserSafeIPsGetUserSafeIpAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return userSafeIPsGetUserSafeIpAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSafeIPsGetUserSafeIpAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSafeIPsGetUserSafeIpAudits(params: UserSafeIPsGetUserSafeIpAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.userSafeIPsGetUserSafeIpAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
